import request from "@/utils/request";
const projectName = "/api/blade-platform";
const projectNameTwo = "/api/blade-workbench";
export const EIdCode = params => {
    return request({
        url: `${projectName}/serviceItem/getMpList`,
        method: "post",
        data: params
    });
};
export const pullDownOption = params => {
    return request({
        url: `${projectNameTwo}/eduFieldConfig/list`,
        method: "post",
        data: params
    });
};
export const save = params => {
    return request({
        url: `${projectName}/digitalCredential/saveConfig`,
        method: "post",
        data: params
    });
};
//参数类型的接口
export const getParamTypeList = params => {
    return request({
        url: `${projectName}/newsSectionConfig/getParamTypeList`,
        method: "get",
    });
};
//资讯栏目API配置】保存API设置"
export const saveConfig = params => {
    return request({
        url: `${projectName}/newsSectionConfig/saveApiFieldMapping`,
        method: "post",
        data: params
    });
};
//资讯栏目API配置】获取API设置"
export const getApiFieldMapping = params => {
    return request({
        url: `${projectName}/newsSectionConfig/getApiFieldMapping`,
        method: "post",
        data: params
    });
};
//资讯栏目列表"
export const getPage = params => {
    return request({
        url: `${projectName}/newsSectionConfig/page`,
        method: "post",
        data: params
    });
};
///api/blade-workbench/eduApiServe/detail
export const detail = params => {
    return request({
        url: `${projectNameTwo}/eduApiServe/detail`,
        method: "post",
        data: params
    });
};
export const detailTwo = params => {
    return request({
        url: `${projectNameTwo}/eduApiServeData/detail`,
        method: "post",
        data: params
    });
};
//新增资讯栏目配置
export const newsSectionConfigSave = params => {
    return request({
        url: `${projectName}/newsSectionConfig/save`,
        method: "post",
        data: params
    });
};
//修改资讯栏目配置
export const newsSectionConfigUpdate = params => {
    return request({
        url: `${projectName}/newsSectionConfig/update`,
        method: "post",
        data: params
    });
};
//【资讯栏目配置】管理公众号-获取公众号列表
export const newsSectionConfigOfficialAccountList = params => {
    return request({
        url: `${projectName}/newsSectionConfig/officialAccountList`,
        method: "post",
        data: params
    });
};
//【资讯栏目配置】管理公众号-删除
export const removeOA = params => {
    return request({
        url: `${projectName}/newsSectionConfig/removeOA`,
        method: "post",
        data: params
    });
};
//【资讯栏目配置】管理公众号-保存公众号列表
export const saveOfficialAccountList = params => {
    return request({
        url: `${projectName}/newsSectionConfig/saveOfficialAccountList`,
        method: "post",
        data: params
    });
};
//【资讯栏目配置】删除指定id的资讯栏目   /api/blade-platform/baseService/roleList
export const remove = params => {
    return request({
        url: `${projectName}/newsSectionConfig/remove`,
        method: "post",
        data: params
    });
};
//【资讯栏目配置】获取角色id   /api/blade-platform/baseService/roleList
export const getRoleList = params => {
    return request({
        url: `${projectName}/baseService/roleList`,
        method: "get",
    });
};
//查询订阅人数
export const mpList = params => {
    return request({
        url: `${projectNameTwo}/im/mp/allMpInfo`,
        method: "post",
        data: params
    });
};
